/**
 * @generated SignedSource<<0ea2e4d11829d63b2176ecb33b966271>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddDoNotRewardTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  rootNodeId: string;
};
export type RewardTreeConfigEditor_AddDoNotRewardConfigMutation$variables = {
  input: AddDoNotRewardTreeConfigInput;
};
export type RewardTreeConfigEditor_AddDoNotRewardConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addDoNotRewardTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"RewardTreeConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type RewardTreeConfigEditor_AddDoNotRewardConfigMutation = {
  response: RewardTreeConfigEditor_AddDoNotRewardConfigMutation$data;
  variables: RewardTreeConfigEditor_AddDoNotRewardConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RewardTreeConfigEditor_AddDoNotRewardConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddDoNotRewardTreeConfigPayload",
                "kind": "LinkedField",
                "name": "addDoNotRewardTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RewardTreeConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RewardTreeConfigEditor_AddDoNotRewardConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddDoNotRewardTreeConfigPayload",
                "kind": "LinkedField",
                "name": "addDoNotRewardTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewardConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "AfterDateTimeDoNotRewardTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "719bc0884364f36bebc8f5eb887fb12e",
    "id": null,
    "metadata": {},
    "name": "RewardTreeConfigEditor_AddDoNotRewardConfigMutation",
    "operationKind": "mutation",
    "text": "mutation RewardTreeConfigEditor_AddDoNotRewardConfigMutation(\n  $input: AddDoNotRewardTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      addDoNotRewardTreeConfig(input: $input) {\n        rootNode {\n          ...RewardTreeConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment NotAfterDateTimeRewardConfigForm_AfterDateTimeDoNotRewardTreeConfigFragment on AfterDateTimeDoNotRewardTreeConfig {\n  id\n  configType\n  dateTime\n}\n\nfragment NotAfterDateTimeRewardConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment RewardTreeConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      rewardConfigs {\n        __typename\n        id\n        configType\n        ... on AfterDateTimeDoNotRewardTreeConfig {\n          dateTime\n        }\n        ...NotAfterDateTimeRewardConfigForm_AfterDateTimeDoNotRewardTreeConfigFragment\n      }\n    }\n  }\n  ...NotAfterDateTimeRewardConfigForm_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "59ab0c18cc48a2389d21968dfdba5871";

export default node;
